import { render, staticRenderFns } from "./ClientSupplementsInstructions.vue?vue&type=template&id=5ecc56a0&scoped=true"
import script from "./ClientSupplementsInstructions.vue?vue&type=script&lang=js"
export * from "./ClientSupplementsInstructions.vue?vue&type=script&lang=js"
import style0 from "./ClientSupplementsInstructions.vue?vue&type=style&index=0&id=5ecc56a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc56a0",
  null
  
)

export default component.exports